import { useCallback, useRef, useState } from 'react';

export type ScrollDirection = 'top' | 'bottom';

/**
 * Хук, вычисляющий направление, в котором таблица была проскролена в последний раз
 *
 * @returns Направление скролла и обработчик изменения вертикального смещения
 */
export const useGridScrollDirection = () => {
    const prevTopScroll = useRef(0);
    const [verticalScrollDirection, setVerticalScrollDirection] = useState<ScrollDirection>('bottom');

    const onScroll = useCallback(
        (scrollTop: number) => {
            if (prevTopScroll.current < scrollTop && verticalScrollDirection !== 'bottom') {
                setVerticalScrollDirection('bottom');
            }

            if (prevTopScroll.current > scrollTop && verticalScrollDirection !== 'top') {
                setVerticalScrollDirection('top');
            }

            prevTopScroll.current = scrollTop;
        },
        [verticalScrollDirection]
    );

    return [{ verticalScrollDirection }, onScroll] as const;
};
